import * as React from 'react'
import RequestParameters from "./requestParameters";
import {useTranslation} from "gatsby-plugin-react-i18next";
import NumberParameter from "./numberParameter";
import TextParameter from "./textParameter";
import ShowAllParametersButton from "../showAllParametersButton";

const TextWatermarkOptions = (props) => {
    const {t} = useTranslation();
    const [text, setText] = React.useState("");
    const [fontName, setFontName] = React.useState("");
    const [fontSize, setFontSize] = React.useState(null);
    const [color, setColor] = React.useState("");
    const [angle, setAngle] = React.useState(null);
    const [hideParameters, setHideParameters] = React.useState(true);

    React.useEffect(() => {
        if (props.disable)
            return;
        const options = [];
        text !== null && text !== "" && options.push({key: "text", value: `"${text}"`});
        fontName !== null && fontName !== "" && options.push({key: "fontName", value: `"${fontName}"`});
        fontSize !== null && fontSize !== "" && options.push({key: "fontSize", value: fontSize});
        color !== null && color !== "" && options.push({key: "color", value: `"${color}"`});
        angle !== null && angle !== "" && options.push({key: "angle", value: angle});
        props.onChange(options)
    }, [text, fontName, fontSize, color, angle])


    return (
        <>
            <RequestParameters disable={props.disable}>
                <TextParameter
                    value={text}
                    required={true}
                    type="string"
                    parameter="text"
                    description={t("watermark-text")}
                    onChange={(e) => setText(e.target.value)}
                    disable={props.disable}/>
                {(!hideParameters || props.disable) && <>
                    <TextParameter
                        value={fontName}
                        type="string"
                        parameter="fontName"
                        description={t("watermark-text-font-name")}
                        onChange={(e) => setFontName(e.target.value)}
                        disable={props.disable}/>

                    <NumberParameter
                        type="int32"
                        value={fontSize === null ? "" : fontSize}
                        parameter="fontSize"
                        description={t("watermark-font-size")}
                        onChange={((e) => setFontSize(e.target.value))}
                        placeholder={72}
                        disable={props.disable}/>

                    <TextParameter
                        value={color}
                        type="string"
                        parameter="color"
                        description={t("watermark-color")}
                        onChange={(e) => setColor(e.target.value)}
                        placeholder="#000000"
                        disable={props.disable}/>

                    <NumberParameter
                        type="int32"
                        value={angle === null ? "" : angle}
                        parameter="angle"
                        description={t("watermark-angle")}
                        onChange={((e) => setAngle(e.target.value))}
                        placeholder={0}
                        disable={props.disable}/>
                </>}
            </RequestParameters>
            {!props.disable && <ShowAllParametersButton value={hideParameters}
                                     onClick={() => setHideParameters(!hideParameters)}/>}
        </>
    );
}

export default TextWatermarkOptions;